import React, {useState} from "react";
import { useTranslation } from "react-i18next";
import { CustomTextField } from "../../../../../../components/CustomTextField";
import ButtonIcon from "../../../../../../components/buttons/ButtonIcon";
import {
    CleanIcon,
    IconAccessRight,
    IconPersonArrow,
    TrashOutlineIcon
} from "../../../../../../components/buttons/IconButtons";
import { STEPS_CREATE_WORK_SHIFT } from "../../Model/Models";
import WorkShiftAccessCard from "../../Modal/WorkShiftAccessCard";
import BufferSchedulesTable from "../BufferSchedulesTable";
import TitledCard from "../TitledCard";
import ButtonAction from "../../../../../../components/buttons/ButtonAction";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azapata@ibl.mx
 *
 * First work shift section: shift name + the schedule builder (zone tree +
 * day/time selector) and its schedules table. In both create and update the
 * schedules live in a client-side buffer (BufferSchedulesTable): the builder
 * adds to it and the delete button removes from it, with no server round-trip.
 * Nothing is committed until the user creates / updates, so leaving or reloading
 * never loses the original schedules. Update seeds the buffer from the server
 * detail on load.
 */
const SectionWorkShift = ({
                              id,
                              item,
                              handleChange,
                              emptyFields,
                              disabled,
                              handleClearStep,
                              schedules,
                              setSchedules,
                              selectDeleteSchedules,
                              setSelectDeleteSchedules,
                              setModified
                          }) => {
    const { t } = useTranslation();
    const isCreate = id === null || typeof id === 'undefined';
    const [triggerDeleteSchedules, setTriggerDeleteSchedules] = useState(false);
    const [triggerClearPicker, setTriggerClearPicker] = useState(false);

    // Both flows keep the section list in `schedules`, so the required flag reads its length.
    const showRequiredSchedules = emptyFields && (schedules || []).length === 0;

    return (
            <div className={"row mb-3"}>
                <div className='d-flex justify-content-end col-12 mb-2'>
                    {isCreate &&
                        <ButtonIcon
                            className='btn-clean-secondary-600'
                            id='btn_sws_clean_work_shift'
                            Icon={CleanIcon}
                            title={'clear_instances'}
                            onClick={() => {
                                handleClearStep(STEPS_CREATE_WORK_SHIFT.WORK_SHIFT.INDEX);
                                setTriggerClearPicker(true);
                            }}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                        />
                    }
                </div>

                <div className={"col-12"}>
                    <CustomTextField
                        id='txt_sws_name'
                        name='name'
                        value={item?.name}
                        trans='name'
                        type='text'
                        disabled={disabled}
                        onChange={handleChange}
                        emptyFields={emptyFields && (item?.name === '' || !item?.name)}
                        required={true}
                        length={64}
                    />
                </div>
                <div className={"col-12"}>
                    <div className={"row"}>
                        <div className={"col-12 col-lg-7 d-flex pl-0 pr-2"}>
                            <TitledCard
                                title={'work_shift'}
                                icon={<IconPersonArrow className={"mr-8px mb-1 icon-color-general-950"} />}
                            >
                                <WorkShiftAccessCard
                                    id={id}
                                    setModified={setModified}
                                    schedules={schedules}
                                    setSchedules={setSchedules}
                                    triggerClear={triggerClearPicker}
                                    setTriggerClear={setTriggerClearPicker}
                                />
                            </TitledCard>
                        </div>
                        <div className={"col-12 col-lg-5 d-flex flex-column pr-0 pl-2"}>
                            <TitledCard
                                title={'access_right'}
                                icon={<IconAccessRight className={"mr-8px mb-1 icon-color-general-950"}/>}
                                borderClass={showRequiredSchedules ? 'border-full-error-code-600' : 'border-full-shades-300'}
                                headerEnd={
                                            <ButtonAction
                                                id='btn_sws_delete'
                                                name='delete'
                                                className='btn-icon-delete p-0'
                                                Icon={TrashOutlineIcon}
                                                onClick={() => setTriggerDeleteSchedules(true)}
                                                disabled={!(selectDeleteSchedules?.length > 0)}
                                            />
                                }
                            >
                                <BufferSchedulesTable
                                    triggerDelete={triggerDeleteSchedules}
                                    setTriggerDelete={setTriggerDeleteSchedules}
                                    schedules={schedules}
                                    setSchedules={setSchedules}
                                    selectForDelete={selectDeleteSchedules}
                                    setSelectForDelete={setSelectDeleteSchedules}
                                />
                            </TitledCard>
                            {showRequiredSchedules &&
                                <span className={`ibl-font-w-700 fs-10px font-color-error-600`}>{t('requiredField')}</span>
                            }
                        </div>
                    </div>
                </div>
            </div>
    );
}

export default SectionWorkShift
